<ng-container *ngIf="currentScope$ | async as currentScope">
  <scope-tab
    *ngIf="
      (currentScope?.identity?.identificationType === 'SCOPE_BY_WORK' ||
        currentScope?.identity?.identificationType === 'SCOPE_BY_SCENARIO') &&
      currentTab === 'Scope'
    "
    [scopeVersion]="currentScope"
    [availableRoles]="removeDuplicates(availableRoles$ | async)"
    [breadcrumbs]="findReplaceBreadcrumbs$ | async"
    [isLoading]="isFindReplaceLoading$ | async"
    [deliverablesCount]="(findReplaceBreadcrumbs$ | async)?.length"
    [filteredRoles]="findReplaceService.filteredRoles$ | async"
    [revertSummaryResponse]="revertSummaryResponse$ | async"
    [replaceSummarySuccess]="replaceSummarySuccess$ | async"
    [replaceSummaryResponse]="replaceSummaryResponse$ | async"
    [revertSummarySuccess]="revertSummarySuccess$ | async"
    [availableDeliverables]="availableDeliverables$ | async"
    [availableComponents]="availableComponents$ | async"
    [availableDepartments]="removeDuplicates(availableDepartments$ | async)"
    [filters$]="scopeOverviewFilters$"
    [searchedComponents$]="searchedComponents$"
    [searchedDepartments$]="searchedDepartments$"
    [searchedRoles$]="searchedRoles$"
    [showFilterView]="showFilterView"
    [filteredSections$]="filteredSections$"
    [filteredDeliverables$]="filteredDeliverables$"
    [filteredComponents$]="filteredComponents$"
    [filteredDepartments$]="filteredDepartments$"
    [filteredRoles$]="filteredRoles$"
    [filteredScopeFees$]="filteredScopeFees$"
    [filteredDeliverableFees$]="filteredDeliverableFees$"
    [filteredComponentFees$]="filteredComponentFees$"
    [filteredDeliverableTPCs$]="filteredDeliverableTPCs$"
    [filteredDeliverableSectionTPCs$]="filteredDeliverableSectionTPCs$"
    [filteredComponentTPCs$]="filteredComponentTPCs$"
    [filterPreferences]="scopeColumnFilterPreferences$ | async"
    [currentUser]="loggedInUser"
    [currentRatecard]="rateCard$ | async"
    [showUseRetainedTeamToggle]="showUseRetainedTeamToggle"
    [scopeRetainedHoursStats]="scopeRetainedHoursStats$ | async"
    [cdnConfig]="cdnConfig"
    (onSearch)="onSearch($event)"
    (onSearchReplaceRoleEvent)="onSearchReplaceRole($event)"
    (onSelectionChange)="onSelectionChange($event)"
    (onRevert)="onRevert($event)"
    (onSubmitFindReplace)="submitReplacedRoles($event)"
    (onAddScopeSection)="addScopeSection(currentScope)"
    (onArchiveScope)="archiveScope(currentScope)"
    (onUnarchiveScope)="unarchiveScope(currentScope)"
    (onCreateDeliverable)="createDeliverable(currentScope)"
    (onCreateFixedFee)="createDeliverable(currentScope, true)"
    (onFetchDeliverable)="fetchDeliverable($event)"
    (onUpdateDeliverable)="updateDeliverable($event)"
    (onMoveDeliverable)="moveDeliverable($event)"
    (onUpdateComponent)="updateComponent($event)"
    (onMoveComponent)="moveComponent($event, currentScope)"
    (onMoveComponentOutsideDeliverable)="moveComponentOutsideDeliverable($event, currentScope)"
    (onDeleteScope)="deleteScope(currentScope)"
    (onDeleteScopeSection)="deleteScopeSection($event, currentScope)"
    (onDuplicateDeliverable)="duplicateDeliverable($event)"
    (onDeleteDeliverable)="deleteDeliverable($event)"
    (onDeleteFee)="deleteFee($event)"
    (onDeleteComponent)="deleteComponent($event)"
    (onSearchComponents)="onSearchComponents($event, currentScope)"
    (onSearchDepartments)="onSearchDepartments($event, currentScope)"
    (onSearchRoles)="onSearchRoles($event, currentScope)"
    (onFilterScope)="onFilterScopes($event, currentScope)"
    (onAcceptDeliverable)="acceptDeliverable($event)"
    (onRejectDeliverable)="rejectDeliverable($event)"
    (onAddFee)="addFee(currentScope.identity?.rateCard.currencyCode, $event)"
    (onAddAndLinkFee)="addAndLinkFee(currentScope)"
    (onEditFee)="editFee($event, currentScope.identity?.rateCard.currencyCode)"
    (onUpdateFee)="updateFee($event)"
    (onTradeDeliverable)="tradeDeliverableModal($event, currentScope)"
    (onCompleteTrade)="completeTradeModal($event, currentScope)"
    (onStopProgressTrade)="stopProgressTradeModal($event, currentScope)"
    (onConfirmTrade)="confirmTradeModal($event)"
    (onCancelTrade)="cancelTradeModal($event, currentScope)"
    (onReopenTrade)="reopenTradeModal($event, currentScope)"
    (onRefreshActuals)="refreshActuals(currentScope)"
    (onAddDeliverableToTrade)="tradeDeliverableModal($event, currentScope)"
    (onShowDeliverableApplyLocationCardDialog)="showDeliverableApplyLocationCardDialog($event)"
    (onAddDiscount)="addDiscount(currentScope)"
    (onDeleteDiscount)="deleteDiscount(currentScope)"
    (onEditMsaLineItem)="editMsaLineItem(currentScope)"
    (onDeleteMsaLineItem)="deleteMsaLineItem($event, currentScope)" />

  <scope-by-role-tab
    *ngIf="currentScope?.identity?.identificationType === 'SCOPE_BY_ROLE' && currentTab === ScopeOverviewTab.SCOPE"
    [scopeVersion]="currentScope"
    [currentUser]="loggedInUser"
    [currentRatecard]="rateCard$ | async"
    [cdnConfig]="cdnConfig"
    [sortedDefaultSectionDeliverables]="sortedDefaultSectionDeliverables$ | async"
    (onArchiveScope)="archiveScope(currentScope)"
    (onUnarchiveScope)="unarchiveScope(currentScope)"
    (onAddTask)="addTask(currentScope.identity?.rateCard.id)"
    (onDeleteScope)="deleteScope(currentScope)"
    (onExport)="exportScopeByRole(currentScope)"
    (onDeleteDeliverable)="deleteDeliverable($event)"
    (onDeleteFee)="deleteFee($event)"
    (onAddFee)="addFee(currentScope.identity?.rateCard.currencyCode, $event)"
    (onEditFee)="editFee($event, currentScope.identity?.rateCard.currencyCode)"
    (onUpdateFee)="updateFee($event)"
    (onAddRole)="addRolesModal(currentScope)"
    (onAddDiscount)="addDiscount(currentScope)"
    (onDeleteDiscount)="deleteDiscount(currentScope)"
    (onEditMsaLineItem)="editMsaLineItem(currentScope)"
    (onDeleteMsaLineItem)="deleteMsaLineItem($event, currentScope)"
    (onAddThirdPartyCost)="addThirdPartyCost(currentScope)"
    (onUpdateThirdPartyCost)="updateThirdPartyCost($event)"
    (onDeleteThirdPartyCost)="deleteScopeThirdPartyCost($event)"
    (onAcceptDeliverable)="acceptDeliverable($event)"
    (onRejectDeliverable)="rejectDeliverable($event)"
    (onAddScopeSection)="addScopeSection(currentScope)"
    (onDeleteScopeSection)="deleteScopeSection($event, currentScope)" />

  <scope-approval-flow
    [stateChecks]="scopeApprovalFlowService.stateChecks"
    [currentUser]="loggedInUser"
    [currentApprovalState]="currentScope.status"
    [isTemplate]="currentScope.identity?.isTemplate"
    [cdnConfig]="cdnConfig"
    [companyIntegrations]="companyIntegrations"
    [currentScope]="currentScope"
    (onWithdrawSubmission)="withdrawSubmissionModal()"
    (onSubmitDraft)="submitDraftScopeModal(currentScope)"
    (onCompleteReview)="completeReviewModal(currentScope)"
    (onAgreeToScope)="agreeToScopeModal(currentScope)"
    (onDeclineScope)="declineScopeModal()"
    (onAcceptScope)="acceptScopeModal()"
    (onRejectScope)="rejectScopeModal()"
    (onCloseScope)="closeScopeModal()"
    (onOpenCreateChangeRequestModal)="openCreateChangeRequestModal()"
    (onSendReminder)="sendNotificationReminder(currentScope)"
    (onAddTeamMember)="showAddTeamMemberModal(currentScope)"
    (onOpenExportModal)="openExportModal(currentScope)"
    (onTrafficExportModal)="openTrafficExportModal(currentScope)" />
</ng-container>
